import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';

/** Reminder under the mapping table: what each group of columns does and does not grant. */
function MappingFooterNote() {
  const { t } = useTranslation('people-access');
  return <p className="text-xs text-content-secondary">{t('import.match.footerNote')}</p>;
}

export default memo(MappingFooterNote);
